import { NavLink } from "react-router-dom";
import { SECTIONS } from "@/lib/sections";
import { Logo } from "@/components/Logo";
import { UserMenu } from "@/components/UserMenu";
import { MobileNav } from "@/components/MobileNav";

const linkClass = ({ isActive }: { isActive: boolean }) =>
  `my-2 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors duration-200 ${
    isActive
      ? "bg-[#16294D] font-semibold text-white"
      : "font-medium text-[#5A6170] hover:bg-[#ECE3D3] hover:text-[#16294D]"
  }`;

export function TopNav() {
  return (
    <header className="sticky top-0 z-40 border-b border-[#CBB898] bg-[#FAF7F1]/95 backdrop-blur-md" data-testid="top-nav">
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-6 px-4 sm:px-8">
        <MobileNav />
        <Logo />
        <nav className="ml-6 hidden items-center gap-1 lg:flex" data-testid="desktop-nav">
          {SECTIONS.map((s) => (
            <NavLink key={s.slug} to={s.path} className={linkClass} data-testid={`nav-link-${s.slug}`}>
              {s.label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto">
          <UserMenu />
        </div>
      </div>
      <nav className="no-scrollbar flex gap-1 overflow-x-auto border-t border-[#E7DECF] px-4 sm:px-8 lg:hidden" data-testid="mobile-scroll-nav">
        {SECTIONS.map((s) => (
          <NavLink key={s.slug} to={s.path} className={linkClass} data-testid={`mobile-tab-${s.slug}`}>
            {s.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
